export default __webpack_public_path__ + "static/media/icon_chevron_left_large.d17236ff.svg";